// extracted by mini-css-extract-plugin
export default {"menuItemComponent":"menuItemComponent--ZOEMf","menuItemComponentWithContext":"menuItemComponentWithContext--LC51b","menuItemContext":"menuItemContext--boPwo"};